import axios from 'axios'
import config from '../config'

export default {
    getProviderSelect() {
        return axios.get(config.publicPath + 'mail_providers', {
            params: {'groups[]': 'select', 'pagination': false, 'order[name]':'asc'},
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}
